/**
 * Why a pending contract event became obsolete.
 *
 * Mirrors the backend enum {@code com.mvs.backend.pd.enums.PdContractEventObsoleteReason} (persisted via
 * {@code @Enumerated(EnumType.ORDINAL)}; the value travels as the ordinal). Member names and order MUST match
 * the backend declaration exactly — append only, never insert, reorder or rename.
 */
export enum PdContractEventObsoleteReasonEnum {
    SUPERSEDED,
    REVERTED,
    CONTRACT_LEFT_PARTNER,
    NOT_RELEVANT,
}
